import React, { useEffect } from "react";
import PageHeader from "../components/pages/contact/PageHeader";
import BecomeAContestant from "../components/pages/contact/BecomeAContestant";
import ContactForm from "../components/pages/contact/ContactForm";
import { Helmet, HelmetProvider } from "react-helmet-async";

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Travel Bloggers | Contester</title>
          <meta name="description" content="Travel Bloggers Awards" />
        </Helmet>
        <div>
          <PageHeader />
          <BecomeAContestant />
          <ContactForm />
        </div>
      </HelmetProvider>
    </>
  );
};

export default ContactPage;
